/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for SDApplication.
 *
 */

import { ReduxUtils } from '@spm/core';

const FETCH_SD_EXTERNALUSER_APPLICATION_STATUS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDAPPLICATION/FETCH_SD_EXTERNALUSER_APPLICATION_STATUS`
);

const FETCH_SD_USER_APPLICATION_INFO = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `SDAPPLICATION/FETCH_SD_USER_APPLICATION_INFO`
);

const SET_IEG_APPLICATION_TYPE = ReduxUtils.generateActionType(
  'ua-library',
  `SDAPPLICATION/SET_IEG_APPLICATION_TYPE`,
  'SET'
);

export {
  FETCH_SD_EXTERNALUSER_APPLICATION_STATUS,
  FETCH_SD_USER_APPLICATION_INFO,
  SET_IEG_APPLICATION_TYPE,
};
